<ng-template #modalAbsenceEvent let-close="close">
	<div class="modal-header">
		<h5 class="modal-title">Nouvelle absence</h5>
		<button type="button" class="btn-close" (click)="modalAbs.hide()">
			<!-- <span aria-hidden="true">&times;</span> -->
		</button>
	</div>
	<div class="modal-body">
		<div class="container-fluid">
			<div class="row p-2">
				<div class="col-md-4 d-flex justify-content-end mt-2 font-weight-bold">
					{{ labelIntervenantCapitalized }} :
				</div>
				<div class="col-md-8">
					<div class="input-group" dropdown *ngIf="employeesList">
						<select
							#selectEmployee
							class="form-select shadow"
							id="selectEmployee"
							[ngClass]="{ 'is-invalid': !employeeToSet }"
							(change)="selectItfcAbs(parseJson(selectEmployee.value))"
						>
							<option value="" disabled [selected]="!employeeToSet">
								Selectionnez un intervenant
							</option>
							<option disabled="disabled">-----------------</option>
							<option
								*ngFor="let employee of employeesList; let i = index"
								value="{{ employee | json }}"
								[selected]="
									employeeToSet &&
									employeeToSet.id &&
									employee.id === employeeToSet.id
								"
							>
								{{ employee.firstName + ' ' + employee.lastName }}
							</option>
						</select>
						<div *ngIf="!employeeToSet" class="invalid-feedback">
							<span>Un intervenant est requis</span>
						</div>
					</div>
				</div>
			</div>
			<div class="row p-2">
				<div class="col-md-4 d-flex justify-content-end font-weight-bold mt-2">
					Motif :
				</div>
				<div class="col-md-8">
					<div class="input-group" dropdown *ngIf="vacationTypes">
						<select
							#selectVacationType
							class="form-select shadow"
							id="selectVacationType"
							[ngClass]="{ 'is-invalid': !vacation?.vacationType }"
							(change)="selectAbsenceType(parseJson(selectVacationType.value))"
						>
							<option class="select-hr my-1" value="" disabled selected>
								Selectionnez un motif
							</option>
							<option disabled="disabled">-----------------</option>
							<option
								class="my-1"
								*ngFor="let vacationType of vacationTypes"
								value="{{ vacationType | json }}"
							>
								{{ vacationType.type }}
							</option>
						</select>
						<div *ngIf="!vacation?.vacationType" class="invalid-feedback">
							<span>Un type d'absence est requis</span>
						</div>
						<!-- <button
							id="button-basic"
							dropdownToggle
							type="button"
							class="btn theme-main-color-button width-380px btn-block dropdown-toggle shadow"
							aria-controls="dropdown-basic"
						>
							{{ ddTypeAbs }}
							<span class="caret float-end"></span>
						</button>
						<ul
							id="dropdown-basic"
							*dropdownMenu
							class="dropdown-menu ul-custom-size"
							role="menu"
							aria-labelledby="button-basic"
						>
							<li
								role="menuitem"
								*ngFor="let vacationType of vacationTypes"
								(click)="selectAbsenceType(vacationType)"
							>
								<a class="dropdown-item">{{ vacationType.type }} </a>
							</li>
						</ul> -->
					</div>
				</div>
			</div>

			<div
				class="row mt-1 p-0"
				*ngIf="this.vacation?.vacationType?.workingTimeAccountedFor"
			>
				<div class="alert alert-info text-center" role="alert">
					Le temps de travail sera comptabilisé pour cette absence.
				</div>
			</div>

			<div class="row mt-1 p-2">
				<div class="col-md-4 d-flex justify-content-end mt-3 font-weight-bold">
					Selection des dates :
				</div>
				<div class="col-lg-7 mt-2">
					<input
						class="form-control shadow"
						#drp="bsDaterangepicker"
						bsDaterangepicker
						[(ngModel)]="bsRangeValue"
						(onHidden)="changeDate()"
						[bsConfig]="{ isAnimated: true }"
					/>
				</div>
				<div class="col-lg-1 mt-2">
					<button
						class="btn theme-main-color-button shadow"
						(click)="drp.toggle()"
						[attr.aria-expanded]="drp.isOpen"
						type="button"
					>
						<i class="bi bi-calendar-event-fill" aria-hidden="true"></i>
					</button>
				</div>
			</div>

			<div class="row p-2">
				<div
					class="col-lg-4 d-flex justify-content-end mt-4 pt-2 font-weight-bold"
				>
					Début :
				</div>
				<div class="col-lg-4 pt-1 mt-4">
					<input
						class="form-control shadow"
						value="{{ vacation?.startDate | date: 'dd/MM/yyyy' }}"
						readonly
					/>
				</div>
				<div class="d-flex justify-content-center col-lg-1 pt-2 mt-4">à</div>
				<div class="col-lg-3">
					<timepicker
						[(ngModel)]="dragToSelectEvent.start"
						[showMeridian]="false"
						[minuteStep]="15"
					>
					</timepicker>
				</div>
			</div>
			<div class="row p-2">
				<div
					class="col-lg-4 d-flex justify-content-end mt-4 pt-2 font-weight-bold"
				>
					Fin :
				</div>
				<div class="col-lg-4 pt-1 mt-4">
					<input
						class="form-control shadow"
						value="{{ vacation?.endDate | date: 'dd/MM/yyyy' }}"
						readonly
					/>
				</div>
				<div class="d-flex justify-content-center col-lg-1 pt-2 mt-4">à</div>
				<div class="col-lg-3">
					<timepicker
						[(ngModel)]="dragToSelectEvent.end"
						[showMeridian]="false"
						[minuteStep]="15"
					>
					</timepicker>
				</div>
			</div>

			<div class="row p-2">
				<div class="col-md-4 d-flex justify-content-end mt-3 font-weight-bold">
					Notes :
				</div>
				<div class="col-md-8">
					<textarea
						*ngIf="vacation"
						class="form-control"
						id="inputNotes"
						[(ngModel)]="vacation.notes"
					></textarea>
				</div>
			</div>

			<div class="mb-3">
				<div class="form-check form-switch">
					<input
						type="checkbox"
						class="form-check-input theme-main-border-color"
						id="recurrencySwitch"
						[ngClass]="{ 'theme-main-color-check': isEventRecurring }"
						[checked]="isEventRecurring"
						(change)="onSwitchRecurrencyChange()"
						[disabled]="
							vacation?.startDate?.getTime() !== vacation?.endDate?.getTime()
						"
					/>
					<label class="form-check-label" for="recurrencySwitch"
						>Répéter l'absence</label
					>
				</div>
				<div *ngIf="isEventRecurring">
					<app-recurring-event-picker
						[startDate]="vacation?.startDate"
						(datesList)="updateDateList($event)"
					>
					</app-recurring-event-picker>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button ms-auto"
			(click)="modalAbs.hide()"
		>
			Annuler
		</button>
		<button
			type="button"
			class="btn theme-green-button pull-right"
			[disabled]="!isAddingButtonAvailable"
			(click)="confirmAbsence()"
		>
			Confirmer
		</button>
	</div>
</ng-template>
